"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWaitingListTime = createWaitingListTime;
const events_1 = require("../../../events");
const dates_1 = require("../../../utils/dates");
const messages_1 = require("../../shared/messages");
const queries_1 = require("../queries");
function createWaitingListTime({ formatMessage }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.waitingListStartDate);
    if (event === undefined) {
        return { value: "-" };
    }
    const days = (0, dates_1.getNumberOfDays)(event.value, new Date());
    return {
        value: formatMessage(messages_1.genericMessages.days, { days }),
        timestamp: event.timestamp,
        origin: event.origin
    };
}
